import { StartWorkflow } from "../features/start/StartWorkflow";

export function StartPage() {
  return <StartWorkflow />;
}
